/**
 * @deprecated moved to @/utils/env module
 */
export function isServer() {
  // @ts-ignore
  return !process.browser;
}
